var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (this.selectedTriplog)?_c('setup-step5',{attrs:{"vehicle":this.selectedTriplog.vehicle,"standalone-screen":""},on:{"next":_vm.close,"exit":_vm.close}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }